document.addEventListener('DOMContentLoaded', () => {
  const stickyCart = document.querySelector('.c-sticky-cart');
  const productForm = document.querySelector('.product-form product-form--regular'); // 通常の商品フォームのセレクタに合わせてください
  let showThreshold = 200; // 表示を開始するスクロール位置 (px)

  if (productForm) {
    const rect = productForm.getBoundingClientRect();
    // 商品フォームが表示されなくなる少し手前から表示する
    showThreshold = rect.top + window.scrollY - 100; 
  }


  function toggleStickyCartVisibility() {
    if (!stickyCart) return;

    if (window.scrollY > showThreshold) {
      stickyCart.classList.add('is-visible');
    } else {
      stickyCart.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', toggleStickyCartVisibility, { passive: true });
  toggleStickyCartVisibility(); // 初期表示チェック
});


document.addEventListener('quantity:changed', (event) => {
	const quantityInput = event.detail.element.input;
	const productFormId = quantityInput.getAttribute('form');
	const sameFormQuantityInputList = document.querySelectorAll(`input[form="${productFormId}"]`);
	sameFormQuantityInputList.forEach(input => {
		if(input.id !== quantityInput.id) {
			input.value = quantityInput.value;
		}
	});
});
